import { render, staticRenderFns } from "./ExternalFile.vue?vue&type=template&id=16dadaea"
import script from "./ExternalFile.vue?vue&type=script&lang=js"
export * from "./ExternalFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports